import React from "react";
import _ from "lodash";
import PropertyMaps from "../../constants/PropertyMaps";
import AppConstants from "../../constants/AppConstants";
import AssetManager from "../../managers/AssetManager";
import StyleUtils, { FORMAT_REACT } from "../../utils/StyleUtils";
import DesignContextUtils from "../../utils/DesignContextUtils";
import { PREVIEW_URL_OP_FILE } from "../../constants/DesignContextConstants";

const {
  BG_PROPERTY_BG_COLOR,
  BG_PROPERTY_FILL_TYPE,
  BG_PROPERTY_POSITION,
  BG_PROPERTY_OPACITY,
  BG_PROPERTY_SCALE,
  BG_PROPERTY_MEDIA_TYPE,
  BG_PROPERTY_IMAGE,
  BG_PROPERTY_VIDEO,
  BG_TYPE_COLOR,
  BG_PROPERTY_REPEAT,
  BG_TYPE_NONE,
  BG_PROPERTY_POSITION_MIDDLE_CENTER,
  BG_PROPERTY_SCALE_COVER,
  BG_PROPERTY_ASSET_KEY,
  MAX_HEIGHT_100,
  MAX_WIDTH_100,
} = AppConstants;

const getBackgroundColor = (background, theme) =>
  StyleUtils.getStyle(
    [BG_PROPERTY_BG_COLOR],
    background,
    theme,
    FORMAT_REACT,
    PropertyMaps.STYLE_PROPS_BG_OVERRIDE
  );

const Background = ({ background, width, theme, designContext }) => {
  let style = {
    position: "absolute",
    width: MAX_WIDTH_100,
    height: MAX_HEIGHT_100,
  };
  const { generateDesignAssetUrl } = DesignContextUtils.fromContext(designContext);

  const mediaType = background
    ? background.get(BG_PROPERTY_MEDIA_TYPE, BG_TYPE_NONE)
    : AppConstants.BG_TYPE_NONE;
  const fillType = background
    ? background.get(BG_PROPERTY_FILL_TYPE, BG_TYPE_COLOR)
    : BG_TYPE_COLOR;
  let content = null;
  if (background) {
    const bgInlineStyle =
      fillType === AppConstants.BG_TYPE_GRADIENT
        ? StyleUtils.getGradientStyle(background, theme)
        : getBackgroundColor(background, theme);
    style = _.merge(style, bgInlineStyle);

    let bgURL = false;
    const bgStyle = {
      width: MAX_WIDTH_100,
      height: MAX_HEIGHT_100,
    };

    if (mediaType === AppConstants.BG_TYPE_IMAGE) {
      const image = background.get(BG_PROPERTY_IMAGE, false);
      if (image) {
        const size = AssetManager.determineSize(width);
        const key = image.get(BG_PROPERTY_ASSET_KEY);
        bgURL = generateDesignAssetUrl({ key, op: size, provider: image.get("provider") });
        bgStyle.backgroundRepeat =
          PropertyMaps.BG_REPEAT_VALUE_MAP[background.get(BG_PROPERTY_REPEAT, BG_TYPE_NONE)];
      }
    } else if (mediaType === AppConstants.BG_TYPE_VIDEO) {
      const video = background.get(BG_PROPERTY_VIDEO, false);
      if (video) {
        const key = video.get(BG_PROPERTY_ASSET_KEY);
        bgURL = generateDesignAssetUrl({ key, op: PREVIEW_URL_OP_FILE });
        bgStyle.backgroundRepeat = PropertyMaps.BG_REPEAT_VALUE_MAP[BG_TYPE_NONE];
      }
    }

    if (bgURL) {
      bgStyle.backgroundImage = "url(" + bgURL + ")";
      bgStyle.opacity = parseInt(background.get(BG_PROPERTY_OPACITY, 100)) / 100;
    }
    bgStyle.backgroundSize =
      PropertyMaps.BG_SCALE_VALUE_MAP[background.get(BG_PROPERTY_SCALE, BG_PROPERTY_SCALE_COVER)];
    bgStyle.backgroundPosition =
      PropertyMaps.BG_POSITION_VALUE_MAP[
        background.get(BG_PROPERTY_POSITION, BG_PROPERTY_POSITION_MIDDLE_CENTER)
      ];

    content = <div style={bgStyle}></div>;
  }

  return <div style={style}>{content}</div>;
};

export default Background;
